import { ProductType } from '../../../hooks/useProducts';
import {
  formatNumber,
  formatNumberWithDecimals,
  formatPercentWithDecimals,
} from '../../../lib/formatters';
import { Gwei } from '../../../lib/gwei';
import { getDecimalPlaces } from '../../../lib/math';
import { CryptoLogo } from '../../CryptoLogo';

export const MarketDetails = ({ product }: { product: ProductType }) => {
  const DetailRow = ({ label, value }: { label: string; value: React.ReactNode }) => (
    <div className="flex justify-between py-2 text-xs">
      <span className="text-contentSecondary">{label}</span>
      <span className="text-contentPrimary">{value}</span>
    </div>
  );

  const decimals = getDecimalPlaces(product.lotSize);

  return (
    <div className="flex h-full">
      {/* Left side - Logo and pair */}
      <div className="flex w-1/4 flex-col items-center pt-[5%]">
        <CryptoLogo tokenName={product.baseTokenName} size={48} />
        <span className="pt-2 text-lg font-bold text-contentPrimary">{product.displayTicker}</span>
        <span className="text-contentSecondary">Perpetuals</span>
      </div>

      {/* Divider */}
      <div className="h-full border-l border-borderPrimary" />

      {/* Right side - Market configuration details */}
      <div className="flex flex-1 flex-col p-6">
        <h2 className="pb-2 text-lg">Market Configuration</h2>

        <DetailRow label="Ticker" value={product.displayTicker} />
        <DetailRow label="Tick Size" value={`$${formatNumberWithDecimals(product.tickSize)}`} />
        <DetailRow
          label="Step Size"
          value={`${formatNumberWithDecimals(product.lotSize)} ${product.baseTokenName}`}
        />
        <DetailRow
          label="Min Order Size"
          value={`${formatNumber(product.minQuantity, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} ${product.baseTokenName}`}
        />
        <DetailRow
          label="Max Order Size"
          value={`${formatNumber(product.maxQuantity, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ${product.baseTokenName}`}
        />
        <DetailRow label="Max Leverage" value={`${product.maxLeverage}x`} />
        <DetailRow
          label="Maintenance Margin Fraction"
          value={formatPercentWithDecimals(Gwei.toGwei(product.maintenanceMarginRatio))}
        />
        <DetailRow
          label="Initial Margin Fraction"
          value={formatPercentWithDecimals(Gwei.toGwei(product.initialMarginRatio))}
        />
      </div>
    </div>
  );
};
